import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ModalOpenLoader from 'component/loader_component/modalOpenLoader';
import { AutoComplete, Form, Input, Select, Tooltip } from 'antd';
import {
  ButtonWrap,
  ContentWrapper,
  ForgetRuleContentWrap,
  HeadingColumn,
  HeadingData,
  LinkSystemWrap,
  PLusSymbol,
  RuleWrap,
  TableContainer,
  TableWrap,
  Wrap,
} from './style';
import { SweetSweetAlert } from 'component/sweetalert_components';
import { LeftArrowIcon } from 'assets/icons/AntDeisgn_icons/iconStyle';
import { AntDivider, AntToggleButton } from 'component/form_component/style';
import { AdminPageSizeWrap, AdminPageWrap, AdminTitleWrap } from 'pages/admin_page/style';
import {
  getOuAdminRights,
  getPortalAdminRights,
  getSettingPageDetails,
  updateSettingPage,
} from 'redux/slices/settingsSlice';
import { ReactComponent as InfoIcon } from 'assets/images/SVG/icons/info-icon.svg';
import { ReactComponent as QuestionMark } from 'assets/images/SVG/icons/question_mark-icon.svg';
import { BackButton, StyledButton } from 'component/button_components/button_general/ButtonGeneralStyle';
import ReturnSourceInfo from './return_source_info';
import { getBrandings } from 'redux/slices/brandingSlice';
import { EMAIL_BASE_URL } from 'utils/url';

export default function Settings() {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const [manageRights] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [returntoSourceInfo, setReturntoSourceInfo] = useState(false);
  const { data } = useSelector((state) => state.brandings);
  const { SettingsData, mailTemplateData, ouAdminRights, portalAdminRights } = useSelector((state) => state.settings);
  const [viewProperties, setViewProperties] = useState({
    portalUser: true,
    portalOu: true,
    portalGroup: true,
    ouAdminUser: true,
    ouAdminOu: true,
    ouAdminGroup: true,
    passwordAlphabets: false,
    passwordNumbers: false,
  });
  const manageRightsInitialValues = {
    portalAdminRights: {
      portaluserView: portalAdminRights?.portaluserView || true,
      portaluserEdit: portalAdminRights?.portaluserEdit || true,
      portaluserCreate: portalAdminRights?.portaluserCreate || true,
      portaluserCreateBulkUsers: portalAdminRights?.portaluserCreateBulkUsers || true,
      portaluserExport: portalAdminRights?.portaluserExport || true,
      portaluserBulkAction: portalAdminRights?.portaluserBulkAction || true,
      portaluserDelete: portalAdminRights?.portaluserDelete || true,
      portaluserResetPassword: portalAdminRights?.portaluserResetPassword || true,
      portaluserUnlock: portalAdminRights?.portaluserUnlock || true,
      portaluserEnableDisable: portalAdminRights?.portaluserEnableDisable || true,
      portalouView: portalAdminRights?.portalouView || true,
      portalouEdit: portalAdminRights?.portalouEdit || true,
      portalouCreate: portalAdminRights?.portalouCreate || true,
      portalouExport: ouAdminRights?.portalouExport || true,
      portalouDelete: portalAdminRights?.portalouDelete || true,
      portalgroupView: portalAdminRights?.portalgroupView || true,
      portalgroupEdit: portalAdminRights?.portalgroupEdit || true,
      portalgroupCreate: portalAdminRights?.portalgroupCreate || true,
      portalgroupDelete: portalAdminRights?.portalgroupDelete || true,
      portalgroupExport: portalAdminRights?.portalgroupExport || true,
      portalgroupBulkAction: portalAdminRights?.portalgroupBulkAction || true,
    },
    ouAdminRights: {
      ouAdminuserView: ouAdminRights?.ouAdminuserView || true,
      ouAdminuserEdit: ouAdminRights?.ouAdminuserEdit || true,
      ouAdminuserCreate: ouAdminRights?.ouAdminuserCreate || true,
      ouAdminuserCreateBulkUsers: ouAdminRights?.ouAdminuserCreateBulkUsers || true,
      ouAdminuserExport: ouAdminRights?.ouAdminuserExport || true,
      ouAdminuserBulkAction: ouAdminRights?.ouAdminuserBulkAction || true,
      ouAdminuserDelete: ouAdminRights?.ouAdminuserDelete || true,
      ouAdminuserResetPassword: ouAdminRights?.ouAdminuserResetPassword || true,
      ouAdminuserUnlock: ouAdminRights?.ouAdminuserUnlock || true,
      ouAdminuserEnableDisable: ouAdminRights?.ouAdminuserEnableDisable || true,
      ouAdminouView: ouAdminRights?.ouAdminouView || true,
      ouAdminouEdit: ouAdminRights?.ouAdminouEdit || true,
      ouAdminouCreate: ouAdminRights?.ouAdminouCreate || true,
      ouAdminouExport: ouAdminRights?.ouAdminouExport || true,
      ouAdminouDelete: ouAdminRights?.ouAdminouDelete || true,
      ouAdmingroupView: ouAdminRights?.ouAdmingroupView || true,
      ouAdmingroupEdit: ouAdminRights?.ouAdmingroupEdit || true,
      ouAdmingroupCreate: ouAdminRights?.ouAdmingroupCreate || true,
      ouAdmingroupDelete: ouAdminRights?.ouAdmingroupDelete || true,
      ouAdmingroupExport: ouAdminRights?.ouAdmingroupExport || true,
      ouAdmingroupBulkAction: ouAdminRights?.ouAdmingroupBulkAction || true,
    },
  };

  const initialValuesMainForm = {
    forgotPassword: SettingsData?.forgotPassword || true,
    changePassword: SettingsData?.changePassword || true,
    useUpnAsEmail: SettingsData?.useUpnAsEmail || false,
    rememberMe: SettingsData?.rememberMe || true,
    userProfile: SettingsData?.userProfile || true,
    email: SettingsData?.email || true,
    username: SettingsData?.userName || true,
    dateFormat: SettingsData?.dateFormat || 'Mon DD YYYY',
    emailBaseUrl: SettingsData?.emailBaseUrl || EMAIL_BASE_URL,
    returnToSource: SettingsData?.returnToSource || false,
    accessToken: SettingsData?.accessToken || 600,
    linkExpiry: SettingsData?.linkExpiry || 1440,
    mailUserCreation: SettingsData?.mailUserCreation || true,
    mailResetPassword: SettingsData?.mailResetPassword || true,
    mailUnlockUser: SettingsData?.mailUnlockUser || true,
    mailEnableUser: SettingsData?.mailEnableUser || true,
    mailDisableUser: SettingsData?.mailDisableUser || true,
    passwordGenerationLength: SettingsData?.passwordGenerationLength || 12,
    passwordGenerationAlphabets: SettingsData?.passwordGenerationAlphabets || true,
    passwordGenerationNumbers: SettingsData?.passwordGenerationNumbers || true,
    passwordGenerationSpecialCharacters: SettingsData?.passwordGenerationSpecialCharacters || true,
  };

  useEffect(() => {
    dispatch(getSettingPageDetails());
    dispatch(getOuAdminRights());
    dispatch(getPortalAdminRights());
    dispatch(getBrandings());
  }, []);

  // Set the initial values for the main form when Redux state changes
  useEffect(() => {
    SettingsData &&
      form.setFieldsValue({
        forgotPassword: SettingsData.forgotPassword,
        changePassword: SettingsData.changePassword,
        useUpnAsEmail: SettingsData.useUpnAsEmail,
        rememberMe: SettingsData.rememberMe,
        userProfile: SettingsData.userProfile,
        email: SettingsData.email,
        username: SettingsData.userName,
        returnToSource: SettingsData?.returnToSource,
        dateFormat: SettingsData?.dateFormat || 'Mon DD YYYY',
        emailBaseUrl: SettingsData?.emailBaseUrl || EMAIL_BASE_URL,
        accessToken: SettingsData.accessToken ? SettingsData.accessToken : 600,
        linkExpiry: SettingsData.linkExpiry ? SettingsData.linkExpiry : 1440,
        mailUserCreation: SettingsData.mailUserCreation,
        mailResetPassword: SettingsData.mailResetPassword,
        mailUnlockUser: SettingsData.mailUnlockUser,
        mailEnableUser: SettingsData.mailEnableUser,
        mailDisableUser: SettingsData.mailDisableUser,
        passwordGenerationLength: SettingsData.passwordGenerationLength ? SettingsData.passwordGenerationLength : 12,
        passwordGenerationAlphabets: SettingsData.passwordGenerationAlphabets,
        passwordGenerationNumbers: SettingsData.passwordGenerationNumbers,
        passwordGenerationSpecialCharacters: SettingsData.passwordGenerationSpecialCharacters,
      });
    if (!SettingsData?.rememberMe) {
      localStorage.removeItem('rememberedUsername');
      localStorage.removeItem('rememberedPassword');
    }

    portalAdminRights &&
      manageRights.setFieldsValue({
        portalAdminRights: {
          ...portalAdminRights,
        },
      });

    ouAdminRights &&
      manageRights.setFieldsValue({
        ouAdminRights: {
          ...ouAdminRights,
        },
      });
  }, [SettingsData, mailTemplateData, portalAdminRights, ouAdminRights]);
  useEffect(() => {
    if (!portalAdminRights || !ouAdminRights) {
      return;
    }
    setViewProperties({
      ...viewProperties,
      portalUser:
        portalAdminRights &&
        (portalAdminRights.portaluserEdit ||
          portalAdminRights.portaluserDelete ||
          portalAdminRights.portaluserUnlock ||
          portalAdminRights.portaluserResetPassword ||
          portalAdminRights.portaluserEnableDisable),
      portalOu: portalAdminRights && (portalAdminRights.portalouEdit || portalAdminRights.portalouDelete),
      portalGroup: portalAdminRights && (portalAdminRights.portalgroupEdit || portalAdminRights.portalgroupDelete),
      ouAdminUser:
        ouAdminRights &&
        (ouAdminRights.ouAdminuserEdit ||
          ouAdminRights.ouAdminuserDelete ||
          ouAdminRights.ouAdminuserUnlock ||
          ouAdminRights.ouAdminuserResetPassword ||
          ouAdminRights.ouAdminuserEnableDisable),
      ouAdminOu: ouAdminRights && (ouAdminRights.ouAdminouEdit || ouAdminRights.ouAdminouDelete),
      ouAdminGroup: ouAdminRights && (ouAdminRights.ouAdmingroupDelete || ouAdminRights.ouAdmingroupEdit),

      passwordNumbers: SettingsData?.passwordGenerationNumbers && !SettingsData?.passwordGenerationAlphabets,
      passwordAlphabets: !SettingsData?.passwordGenerationNumbers && SettingsData?.passwordGenerationAlphabets,
    });
    setReturntoSourceInfo(SettingsData?.returnToSource);
  }, [portalAdminRights, ouAdminRights, SettingsData]);

  const CheckNumericOrAlpha = (fieldName, checked) => {
    const values = form.getFieldsValue();
    const updateViewProperties = (field, value) => setViewProperties({ ...viewProperties, [field]: value });

    if (fieldName === 'passwordGenerationAlphabets') {
      updateViewProperties('passwordNumbers', !checked && values.passwordGenerationNumbers);
    } else if (fieldName === 'passwordGenerationNumbers') {
      updateViewProperties('passwordAlphabets', !checked && values.passwordGenerationAlphabets);
    }
  };
  const handleReturntoSourceInfo = () => {
    const values = form.getFieldValue('returnToSource');
    setReturntoSourceInfo(values);
  };
  const handleImportEnable = (fieldName) => {
    const { portalAdminRights, ouAdminRights } = manageRights.getFieldsValue();
    if (fieldName === 'portaluserCreateBulkUsers') {
      if (portalAdminRights.portaluserCreate) {
        manageRights.setFieldsValue({
          portalAdminRights: {
            ...portalAdminRights,
            portaluserCreateBulkUsers: true,
          },
        });
      } else {
        SweetSweetAlert({
          sweetData: 'You need to enable Create User rights before enabling Import Users.',
          icon: 'info',
          buttonColor: 'blue',
        });
        manageRights.setFieldsValue({
          portalAdminRights: {
            ...portalAdminRights,
            portaluserCreateBulkUsers: false,
          },
        });
      }
    } else if (fieldName === 'ouAdminuserCreateBulkUsers') {
      if (ouAdminRights.ouAdminuserCreate) {
        manageRights.setFieldsValue({
          ouAdminRights: {
            ...ouAdminRights,
            ouAdminuserCreateBulkUsers: true,
          },
        });
      } else {
        SweetSweetAlert({
          sweetData: 'You need to enable Create User rights before enabling Import Users.',
          icon: 'info',
          buttonColor: 'blue',
        });
        manageRights.setFieldsValue({
          ouAdminRights: {
            ...ouAdminRights,
            ouAdminuserCreateBulkUsers: false,
          },
        });
      }
    } else if (fieldName === 'portaluserCreate') {
      if (portalAdminRights.portaluserCreateBulkUsers) {
        manageRights.setFieldsValue({
          portalAdminRights: {
            ...portalAdminRights,
            portaluserCreateBulkUsers: false,
            portaluserCreate: false,
          },
        });
      }
    } else if (fieldName === 'ouAdminuserCreate') {
      if (ouAdminRights.ouAdminuserCreateBulkUsers) {
        manageRights.setFieldsValue({
          ouAdminRights: {
            ...ouAdminRights,
            ouAdminuserCreateBulkUsers: false,
            ouAdminuserCreate: false,
          },
        });
      }
    }
  };

  const HandleUserViewButton = (value) => {
    const { portalAdminRights, ouAdminRights } = manageRights.getFieldsValue();
    if (value === 'PortalAdminUser') {
      if (
        portalAdminRights.portaluserEdit ||
        portalAdminRights.portaluserDelete ||
        portalAdminRights.portaluserUnlock ||
        portalAdminRights.portaluserResetPassword ||
        portalAdminRights.portaluserEnableDisable ||
        portalAdminRights.portaluserBulkAction
      ) {
        manageRights.setFieldsValue({
          portalAdminRights: {
            ...portalAdminRights,
            portaluserView: true,
          },
        });
        setViewProperties({
          ...viewProperties,
          portalUser: true,
        });
      } else {
        setViewProperties({
          ...viewProperties,
          portalUser: false,
        });
      }
    } else if (value === 'OuAdminUser') {
      if (
        ouAdminRights.ouAdminuserEdit ||
        ouAdminRights.ouAdminuserDelete ||
        ouAdminRights.ouAdminuserUnlock ||
        ouAdminRights.ouAdminuserResetPassword ||
        ouAdminRights.ouAdminuserEnableDisable ||
        ouAdminRights.ouAdminuserBulkAction
      ) {
        manageRights.setFieldsValue({
          ouAdminRights: {
            ...ouAdminRights,
            ouAdminuserView: true,
          },
        });
        setViewProperties({
          ...viewProperties,
          ouAdminUser: true,
        });
      } else {
        setViewProperties({
          ...viewProperties,
          ouAdminUser: false,
        });
      }
    }
  };
  const HandleOuViewButton = (value) => {
    const { portalAdminRights, ouAdminRights } = manageRights.getFieldsValue();
    if (value === 'PortalAdminOU') {
      if (portalAdminRights.portalouEdit || portalAdminRights.portalouDelete) {
        manageRights.setFieldsValue({
          portalAdminRights: {
            ...portalAdminRights,
            portalouView: true,
          },
        });
        setViewProperties({
          ...viewProperties,
          portalOu: true,
        });
      } else {
        setViewProperties({
          ...viewProperties,
          portalOu: false,
        });
      }
    } else if (value === 'OuAdminOU') {
      if (ouAdminRights.ouAdminouEdit || ouAdminRights.ouAdminouDelete) {
        manageRights.setFieldsValue({
          ouAdminRights: {
            ...ouAdminRights,
            ouAdminouView: true,
          },
        });
        setViewProperties({
          ...viewProperties,
          ouAdminOu: true,
        });
      } else {
        setViewProperties({
          ...viewProperties,
          ouAdminOu: false,
        });
      }
    }
  };
  const HandleGroupViewButton = (value) => {
    const { portalAdminRights, ouAdminRights } = manageRights.getFieldsValue();
    if (value === 'PortalAdminGroup') {
      if (
        portalAdminRights.portalgroupEdit ||
        portalAdminRights.portalgroupDelete ||
        portalAdminRights.portalgroupBulkAction
      ) {
        manageRights.setFieldsValue({
          portalAdminRights: {
            ...portalAdminRights,
            portalgroupView: true,
          },
        });
        setViewProperties({
          ...viewProperties,
          portalGroup: true,
        });
      } else {
        setViewProperties({
          ...viewProperties,
          portalGroup: false,
        });
      }
    } else if (value === 'OuAdminGroup') {
      if (ouAdminRights.ouAdmingroupEdit || ouAdminRights.ouAdmingroupDelete || ouAdminRights.ouAdmingroupBulkAction) {
        manageRights.setFieldsValue({
          ouAdminRights: {
            ...ouAdminRights,
            ouAdmingroupView: true,
          },
        });
        setViewProperties({
          ...viewProperties,
          ouAdminGroup: true,
        });
      } else {
        setViewProperties({
          ...viewProperties,
          ouAdminGroup: false,
        });
      }
    }
  };

  const onFinish = async (value) => {
    const manageRightsData = manageRights.getFieldsValue();
    value.emailBaseUrl = value.emailBaseUrl || EMAIL_BASE_URL;
    value.portalAdminRights = manageRightsData.portalAdminRights;
    value.ouAdminRights = manageRightsData.ouAdminRights;
    value.linkExpiry = parseInt(value.linkExpiry);
    value.accessToken = parseInt(value.accessToken);
    value.passwordGenerationLength = parseInt(value.passwordGenerationLength);
    try {
      setLoading(true);
      const sweetAlert = await dispatch(updateSettingPage(value));
      if (sweetAlert.payload && sweetAlert.payload.status === 200) {
        dispatch(getSettingPageDetails());
        dispatch(getOuAdminRights());
        dispatch(getPortalAdminRights());
        SweetSweetAlert({ sweetData: sweetAlert.payload.data, icon: 'success', buttonColor: 'green' });
      } else {
        SweetSweetAlert({ text: 'Something Wrong Please try again.!!', icon: 'error', buttonColor: 'red' });
      }
    } catch (error) {
      SweetSweetAlert({ text: 'Something Wrong Please try again.!!', icon: 'error', buttonColor: 'red' });
    } finally {
      setLoading(false);
    }
  };
  return (
    <AdminPageWrap className='af-superadmin-setting-wrap'>
      <AdminPageSizeWrap className='af-superadmin-setting-content'>
        <BackButton className='af-superadmin-setting-backbutton' to='/'>
          <LeftArrowIcon className='af-superadmin-setting-leftarrow' /> Back
        </BackButton>
        <AdminTitleWrap className='af-superadmin-setting-title-wrap'>
          <h2 className='af-superadmin-setting-title-head' style={{ marginBottom: '0px' }}>
            Settings
          </h2>
        </AdminTitleWrap>
        <AntDivider className='af-superadmin-setting-divider' plain></AntDivider>
        {loading && <ModalOpenLoader />}
        <Form
          className='af-superadmin-setting-form-element'
          form={form}
          onFinish={onFinish}
          initialValues={initialValuesMainForm}
          name='register'
          scrollToFirstError
        >
          <ContentWrapper className='af-superadmin-setting-content-wrap'>
            <h3 className='af-superadmin-setting-general-head'>General Options</h3>
            <Wrap className='wrapextend af-superadmin-setting-general-wrap'>
              <Form.Item
                className='af-superadmin-setting-general-form-item-forgot'
                label='Forgot Password'
                name='forgotPassword'
                valuePropName='checked'
              >
                <AntToggleButton className='af-form-switch af-superadmin-setting-general-forgot-toggle' />
              </Form.Item>
              <Form.Item
                className='af-superadmin-setting-general-form-item-change'
                label='Change Password'
                name='changePassword'
                valuePropName='checked'
              >
                <AntToggleButton className='af-form-switch af-superadmin-setting-general-change-toggle' />
              </Form.Item>
              <Form.Item
                className='af-superadmin-setting-general-form-item-remember'
                label='Remember me'
                name='rememberMe'
                valuePropName='checked'
              >
                <AntToggleButton className='af-form-switch af-superadmin-setting-general-remember-toggle' />
              </Form.Item>
              <Form.Item
                className='af-superadmin-setting-general-form-item-userself'
                label='User Profile Self Edit'
                name='userProfile'
                valuePropName='checked'
              >
                <AntToggleButton className='af-form-switch af-superadmin-setting-general-userself-toggle' />
              </Form.Item>
              <Form.Item
                className='af-superadmin-setting-general-form-item-useEmail'
                label='Use UPN as Email'
                name='useUpnAsEmail'
                valuePropName='checked'
              >
                <AntToggleButton className='af-form-switch af-superadmin-setting-general-useEmail-toggle' />
              </Form.Item>
              <div style={{ display: 'flex' }} className='af-superadmin-setting-general-session-wrap'>
                <Form.Item
                  className='af-superadmin-setting-general-form-item-session'
                  label='Session Timeout'
                  name='accessToken'
                >
                  <Input
                    style={{
                      width: '70px',
                    }}
                    type='number'
                    min={5}
                    max={3600}
                    className='af-superadmin-setting-general-input-session'
                  />
                </Form.Item>
                <p className='af-superadmin-setting-general-session-secs' style={{ marginTop: '4px' }}>
                  &nbsp;secs
                </p>
              </div>
              <div style={{ display: 'flex' }} className='af-superadmin-setting-general-link-wrap'>
                <Form.Item
                  className='af-superadmin-setting-general-form-item-link'
                  label='Password Link Expiry'
                  name='linkExpiry'
                >
                  <Input
                    style={{
                      width: '85px',
                    }}
                    type='number'
                    min={5}
                    className='af-superadmin-setting-general-input-link'
                  />
                </Form.Item>
                <p className='af-superadmin-setting-general-link-mins' style={{ marginTop: '4px' }}>
                  &nbsp;minutes
                </p>
              </div>
              <Form.Item
                className='af-superadmin-setting-general-form-item-dateFormat'
                label='Date Format'
                name='dateFormat'
              >
                <Select
                  style={{
                    width: '140px',
                  }}
                  className='af-superadmin-setting-general-input-link'
                  options={[
                    { label: 'DD-MM-YY', value: 'DD-MM-YY' },
                    { label: 'DD-MM-YYYY', value: 'DD-MM-YYYY' },
                    { label: 'MM-DD-YY', value: 'MM-DD-YY' },
                    { label: 'MM-DD-YYYY', value: 'MM-DD-YYYY' },
                    { label: 'YY-MM-DD', value: 'YY-MM-DD' },
                    { label: 'YYYY-MM-DD', value: 'YYYY-MM-DD' },
                    { label: 'Mon DD YYYY', value: 'MMM DD YYYY' },
                  ]}
                ></Select>
              </Form.Item>
              <Form.Item
                className='af-superadmin-setting-general-form-item-emailBaseUrl'
                label='Email Base URL'
                name='emailBaseUrl'
                tooltip={{
                  title: `This URL will be replaced for {BASEURL} short code when sending emails to users.`,
                  trigger: 'click',
                  icon: <QuestionMark height={20} width={20} style={{ cursor: 'pointer' }} />,
                  overlayInnerStyle: {
                    backgroundColor: '#fff',
                    color: '#000',
                    border: '1px solid black',
                    width: '20em',
                  },
                }}
              >
                <AutoComplete
                  style={{
                    minWidth: '15em',
                  }}
                  className='af-superadmin-setting-general-autocomplete-emailBaseUrl'
                  options={data.map((option) => ({ value: `https://${option.url}` }))}
                />
              </Form.Item>
            </Wrap>
          </ContentWrapper>
          <ContentWrapper className='af-superadmin-setting-content-second-wrap'>
            <h3 className='af-superadmin-setting-forgot-rule-head'>Forgot Password Rule</h3>
            <Wrap className='af-superadmin-setting-forgot-rule-wrap'>
              <ForgetRuleContentWrap className='af-superadmin-setting-forgot-rule-content-wrap'>
                <div className='af-superadmin-setting-forgot-rule-content-wrap'>
                  <p className='af-superadmin-setting-forgot-rule-require'>
                    * Required fields for Forgot Password validation
                  </p>
                  <RuleWrap className='af-superadmin-setting-forgot-rule-email-and-user'>
                    <Form.Item
                      className='af-superadmin-setting-forgot-rule-form-item-user'
                      label='User Name'
                      name='username'
                      valuePropName='checked'
                    >
                      <AntToggleButton
                        disabled
                        className='af-form-switch af-superadmin-setting-forgot-rule-user-toggle'
                      />
                    </Form.Item>
                    <PLusSymbol className='af-form-switch af-superadmin-setting-forgot-rule-plus'>+</PLusSymbol>
                    <Form.Item
                      className='af-superadmin-setting-forgot-rule-form-item-email'
                      label='Email'
                      name='email'
                      valuePropName='checked'
                    >
                      <AntToggleButton className='af-form-switch af-superadmin-setting-forgot-rule-email-toggle' />
                    </Form.Item>
                  </RuleWrap>
                </div>
                <div className='af-superadmin-setting-forgot-rule-linksystem-wrap'>
                  <p className='af-superadmin-setting-forgot-rule-linksystem'>While linking from other systems</p>
                  <LinkSystemWrap className='af-superadmin-setting-forgot-rule-linksystem-button-wrap'>
                    <Form.Item
                      className='af-superadmin-setting-forgot-rule-form-item-returnToSource'
                      label='Return to Source'
                      name='returnToSource'
                      valuePropName='checked'
                    >
                      <AntToggleButton
                        onChange={handleReturntoSourceInfo}
                        className='af-form-switch af-superadmin-setting-forgot-rule-returnToSource-toggle'
                      />
                    </Form.Item>
                    {returntoSourceInfo && (
                      <Tooltip
                        title={<ReturnSourceInfo />}
                        placement='right'
                        color='#f9f9f9'
                        overlayStyle={{ maxWidth: 'min-content' }}
                        className='af-superadmin-setting-forgot-rule-linksystem-icon-info-tooltip'
                      >
                        <InfoIcon className='af-superadmin-setting-forgot-rule-linksystem-icon-info' />
                      </Tooltip>
                    )}
                  </LinkSystemWrap>
                </div>
              </ForgetRuleContentWrap>
            </Wrap>
          </ContentWrapper>
          <ContentWrapper className='af-superadmin-setting-content-third-wrap'>
            <h3 className='af-superadmin-setting-auto-rule-head'>Auto Password Rules</h3>
            <Wrap className='wrapextend af-superadmin-setting-auto-rule-wrap'>
              <Form.Item
                label='Length'
                name='passwordGenerationLength'
                className='af-superadmin-setting-auto-rule-form-item-length'
              >
                <Input
                  style={{
                    width: '70px',
                  }}
                  type='number'
                  min={8}
                  max={25}
                  className='af-superadmin-setting-auto-rule-input-length'
                />
              </Form.Item>
              <Form.Item
                className='af-superadmin-setting-auto-rule-form-item-alpha'
                label='Alphabets'
                name='passwordGenerationAlphabets'
                valuePropName='checked'
              >
                <AntToggleButton
                  className='af-form-switch af-superadmin-setting-auto-rule-alpha-toggle'
                  disabled={viewProperties.passwordAlphabets}
                  onChange={(checked) => CheckNumericOrAlpha('passwordGenerationAlphabets', checked)}
                />
              </Form.Item>
              <Form.Item
                className='af-superadmin-setting-auto-rule-form-item-number'
                label='Numbers:'
                name='passwordGenerationNumbers'
                valuePropName='checked'
              >
                <AntToggleButton
                  className='af-form-switch af-superadmin-setting-auto-rule-number-toggle'
                  disabled={viewProperties.passwordNumbers}
                  onChange={(checked) => CheckNumericOrAlpha('passwordGenerationNumbers', checked)}
                />
              </Form.Item>
              <Form.Item
                className='af-superadmin-setting-auto-rule-form-item-char'
                label='Special Characters'
                name='passwordGenerationSpecialCharacters'
                valuePropName='checked'
              >
                <AntToggleButton className='af-form-switch af-superadmin-setting-auto-rule-char-toggle' />
              </Form.Item>
            </Wrap>
          </ContentWrapper>
          <ContentWrapper className='af-superadmin-setting-content-fourth-wrap'>
            <h3 className='af-superadmin-setting-notify-head'>Email Notifications Defaults</h3>
            <Wrap className='wrapextend af-superadmin-setting-notify-wrap'>
              <Form.Item
                className='af-superadmin-setting-notify-form-item-creatmail'
                label='User Creation'
                name='mailUserCreation'
                valuePropName='checked'
              >
                <AntToggleButton className='af-form-switch af-superadmin-setting-notify-creatmail-toggle' />
              </Form.Item>
              <Form.Item
                className='af-superadmin-setting-notify-form-item-resetmail'
                label='Reset Password'
                name='mailResetPassword'
                valuePropName='checked'
              >
                <AntToggleButton className='af-form-switch af-superadmin-setting-notify-resetmail-toggle' />
              </Form.Item>
              <Form.Item
                className='af-superadmin-setting-notify-form-item-unlockmail'
                label='UnLock User'
                name='mailUnlockUser'
                valuePropName='checked'
              >
                <AntToggleButton className='af-form-switch af-superadmin-setting-notify-unlockmail-toggle' />
              </Form.Item>
              <Form.Item
                className='af-superadmin-setting-notify-form-item-enablemail'
                label='Enable User'
                name='mailEnableUser'
                valuePropName='checked'
              >
                <AntToggleButton className='af-form-switch af-superadmin-setting-notify-enablemail-toggle' />
              </Form.Item>
              <Form.Item
                className='af-superadmin-setting-notify-form-item-disablemail'
                label='Disable User'
                name='mailDisableUser'
                valuePropName='checked'
              >
                <AntToggleButton className='af-form-switch af-superadmin-setting-notify-disablemail-toggle' />
              </Form.Item>
            </Wrap>
          </ContentWrapper>
          <ContentWrapper className='af-superadmin-setting-content-fifth-wrap'>
            <h3 className='af-superadmin-setting-rights-head'>Manage Rights</h3>
            <Form
              className='af-superadmin-setting-rights-form-element'
              form={manageRights}
              initialValues={manageRightsInitialValues}
            >
              <TableWrap className='af-superadmin-setting-rights-tablewrap'>
                <TableContainer className='af-superadmin-setting-rights-table-container'>
                  <div className='table-container af-superadmin-setting-rights-user-wrap'>
                    <table className='custom-table af-superadmin-setting-rights-user-table'>
                      <thead className='af-superadmin-setting-rights-user-table-head'>
                        <tr className='af-table-row af-superadmin-setting-rights-user-table-head-row'>
                          <th className='af-table-th af-superadmin-setting-rights-user-rights-head'>Rights</th>
                          <th className='af-table-th af-superadmin-setting-rights-user-domain-head'>Domain Admin</th>
                          <th className='af-table-th af-superadmin-setting-rights-user-ou-head'>Ou Admin</th>
                        </tr>
                      </thead>
                      <tbody className='af-superadmin-setting-rights-user-table-body'>
                        <tr className='af-table-row af-superadmin-setting-rights-user-body-head'>
                          <HeadingColumn colSpan='3' className='af-superadmin-setting-rights-user-head-column'>
                            <HeadingData className='af-superadmin-setting-rights-user-head-data'>
                              User Management
                            </HeadingData>
                          </HeadingColumn>
                        </tr>
                        <tr className='af-table-row af-superadmin-setting-rights-user-body-view'>
                          <td className='af-table-data af-superadmin-setting-rights-user-data-view'>View</td>
                          <td className='af-table-data af-superadmin-setting-rights-user-data-toggle-domain-view'>
                            <Form.Item
                              className='af-superadmin-setting-rights-user-form-item-domainview'
                              name={['portalAdminRights', 'portaluserView']}
                              valuePropName='checked'
                            >
                              <AntToggleButton
                                className='af-form-switch af-superadmin-rights-user-toggle-domainview'
                                disabled={viewProperties.portalUser}
                              />
                            </Form.Item>
                          </td>

                          <td className='af-table-data af-superadmin-setting-rights-user-data-toggle-ou-view'>
                            <Form.Item
                              className='af-superadmin-setting-rights-user-form-item-ouview'
                              name={['ouAdminRights', 'ouAdminuserView']}
                              valuePropName='checked'
                            >
                              <AntToggleButton
                                className='af-form-switch af-superadmin-rights-user-toggle-ouview'
                                disabled={viewProperties.ouAdminUser}
                              />
                            </Form.Item>
                          </td>
                        </tr>
                        <tr className='af-table-row af-superadmin-setting-rights-user-body-edit'>
                          <td className='af-table-data af-superadmin-setting-rights-user-data-edit'>Edit</td>
                          <td className='af-table-data af-superadmin-setting-rights-user-data-toggle-domain-edit'>
                            <Form.Item
                              className='af-superadmin-setting-rights-user-form-item-domainedit'
                              name={['portalAdminRights', 'portaluserEdit']}
                              valuePropName='checked'
                            >
                              <AntToggleButton
                                className='af-superadmin-setting-rights-user-form-item-domainedit'
                                onChange={() => HandleUserViewButton('PortalAdminUser')}
                              />
                            </Form.Item>
                          </td>
                          <td className='af-table-data af-superadmin-setting-rights-user-data-toggle-ou-edit'>
                            <Form.Item
                              className='af-superadmin-setting-rights-user-form-item-ouedit'
                              name={['ouAdminRights', 'ouAdminuserEdit']}
                              valuePropName='checked'
                            >
                              <AntToggleButton
                                className='af-form-switch af-superadmin-rights-user-toggle-ouedit'
                                onChange={() => HandleUserViewButton('OuAdminUser')}
                              />
                            </Form.Item>
                          </td>
                        </tr>
                        <tr className='af-table-row af-superadmin-setting-rights-user-body-create'>
                          <td className='af-table-data af-superadmin-setting-rights-user-data-create'>Create</td>
                          <td className='af-table-data af-superadmin-setting-rights-user-data-toggle-domain-create'>
                            <Form.Item
                              className='af-superadmin-setting-rights-user-form-item-domaincreate'
                              name={['portalAdminRights', 'portaluserCreate']}
                              valuePropName='checked'
                            >
                              <AntToggleButton
                                className='af-form-switch af-superadmin-rights-user-toggle-domaincreate'
                                onChange={(checked) => !checked && handleImportEnable('portaluserCreate')}
                              />
                            </Form.Item>
                          </td>
                          <td className='af-table-data af-superadmin-setting-rights-user-data-toggle-ou-create'>
                            <Form.Item
                              className='af-superadmin-setting-rights-user-form-item-oucreate'
                              name={['ouAdminRights', 'ouAdminuserCreate']}
                              valuePropName='checked'
                            >
                              <AntToggleButton
                                className='af-form-switch af-superadmin-rights-user-toggle-oucreate'
                                onChange={(checked) => !checked && handleImportEnable('ouAdminuserCreate')}
                              />
                            </Form.Item>
                          </td>
                        </tr>
                        <tr className='af-table-row af-superadmin-setting-rights-user-body-import'>
                          <td className='af-table-data af-superadmin-setting-rights-user-data-import'>Import Users</td>
                          <td className='af-table-data af-superadmin-setting-rights-user-data-toggle-domain-import'>
                            <Form.Item
                              className='af-superadmin-setting-rights-user-form-item-domainimport'
                              name={['portalAdminRights', 'portaluserCreateBulkUsers']}
                              valuePropName='checked'
                            >
                              <AntToggleButton
                                className='af-form-switch af-superadmin-rights-user-toggle-domainimport'
                                onChange={(checked) => checked && handleImportEnable('portaluserCreateBulkUsers')}
                              />
                            </Form.Item>
                          </td>
                          <td className='af-table-data af-superadmin-setting-rights-user-data-toggle-ou-import'>
                            <Form.Item
                              className='af-superadmin-setting-rights-user-form-item-ouimport'
                              name={['ouAdminRights', 'ouAdminuserCreateBulkUsers']}
                              valuePropName='checked'
                            >
                              <AntToggleButton
                                className='af-form-switch af-superadmin-rights-user-toggle-ouimport'
                                onChange={(checked) => checked && handleImportEnable('ouAdminuserCreateBulkUsers')}
                              />
                            </Form.Item>
                          </td>
                        </tr>
                        <tr className='af-table-row af-superadmin-setting-rights-user-body-export'>
                          <td className='af-table-data af-superadmin-setting-rights-user-data-export'>Export</td>
                          <td className='af-table-data af-superadmin-setting-rights-user-data-toggle-domain-export'>
                            <Form.Item
                              className='af-superadmin-setting-rights-user-form-item-domainexport'
                              name={['portalAdminRights', 'portaluserExport']}
                              valuePropName='checked'
                            >
                              <AntToggleButton className='af-form-switch af-superadmin-rights-user-toggle-domainexport' />
                            </Form.Item>
                          </td>
                          <td className='af-table-data af-superadmin-setting-rights-user-data-toggle-ou-export'>
                            <Form.Item
                              className='af-superadmin-setting-rights-user-form-item-ouexport'
                              name={['ouAdminRights', 'ouAdminuserExport']}
                              valuePropName='checked'
                            >
                              <AntToggleButton className='af-form-switch af-superadmin-rights-user-toggle-ouexport' />
                            </Form.Item>
                          </td>
                        </tr>
                        <tr className='af-table-row af-superadmin-setting-rights-user-body-bulk'>
                          <td className='af-table-data af-superadmin-setting-rights-user-data-bulk'>Bulk Actions</td>
                          <td className='af-table-data af-superadmin-setting-rights-user-data-toggle-domain-bulk'>
                            <Form.Item
                              className='af-superadmin-setting-rights-user-form-item-domainbulk'
                              name={['portalAdminRights', 'portaluserBulkAction']}
                              valuePropName='checked'
                            >
                              <AntToggleButton
                                className='af-form-switch af-superadmin-rights-user-toggle-domainbulk'
                                onChange={() => HandleUserViewButton('PortalAdminUser')}
                              />
                            </Form.Item>
                          </td>
                          <td className='af-table-data af-superadmin-setting-rights-user-data-toggle-ou-bulk'>
                            <Form.Item
                              className='af-superadmin-setting-rights-user-form-item-oubulk'
                              name={['ouAdminRights', 'ouAdminuserBulkAction']}
                              valuePropName='checked'
                            >
                              <AntToggleButton
                                className='af-form-switch af-superadmin-rights-user-toggle-oubulk'
                                onChange={() => HandleUserViewButton('OuAdminUser')}
                              />
                            </Form.Item>
                          </td>
                        </tr>
                        <tr className='af-table-row af-superadmin-setting-rights-user-body-delete'>
                          <td className='af-table-data af-superadmin-setting-rights-user-data-delete'>Delete</td>
                          <td className='af-table-data af-superadmin-setting-rights-user-data-toggle-domain-delete'>
                            <Form.Item
                              className='af-superadmin-setting-rights-user-form-item-domaindelete'
                              name={['portalAdminRights', 'portaluserDelete']}
                              valuePropName='checked'
                            >
                              <AntToggleButton
                                className='af-form-switch af-superadmin-rights-user-toggle-domaindelete'
                                onChange={() => HandleUserViewButton('PortalAdminUser')}
                              />
                            </Form.Item>
                          </td>
                          <td className='af-table-data af-superadmin-setting-rights-user-data-toggle-ou-delete'>
                            <Form.Item
                              className='af-superadmin-setting-rights-user-form-item-oudelete'
                              name={['ouAdminRights', 'ouAdminuserDelete']}
                              valuePropName='checked'
                            >
                              <AntToggleButton
                                className='af-form-switch af-superadmin-rights-user-toggle-oudelete'
                                onChange={() => HandleUserViewButton('OuAdminUser')}
                              />
                            </Form.Item>
                          </td>
                        </tr>
                        <tr className='af-table-row af-superadmin-setting-rights-user-body-reset'>
                          <td className='af-table-data af-superadmin-setting-rights-user-data-reset'>Reset Password</td>
                          <td className='af-table-data af-superadmin-setting-rights-user-data-toggle-domain-reset'>
                            <Form.Item
                              className='af-superadmin-setting-rights-user-form-item-domainreset'
                              name={['portalAdminRights', 'portaluserResetPassword']}
                              valuePropName='checked'
                            >
                              <AntToggleButton
                                className='af-form-switch af-superadmin-rights-user-toggle-domainreset'
                                onChange={() => HandleUserViewButton('PortalAdminUser')}
                              />
                            </Form.Item>
                          </td>
                          <td className='af-table-data af-superadmin-setting-rights-user-data-toggle-ou-reset'>
                            <Form.Item
                              className='af-superadmin-setting-rights-user-form-item-oureset'
                              name={['ouAdminRights', 'ouAdminuserResetPassword']}
                              valuePropName='checked'
                            >
                              <AntToggleButton
                                className='af-form-switch af-superadmin-rights-user-toggle-oureset'
                                onChange={() => HandleUserViewButton('OuAdminUser')}
                              />
                            </Form.Item>
                          </td>
                        </tr>
                        <tr className='af-table-row af-superadmin-setting-rights-user-body-unlock'>
                          <td className='af-table-data af-superadmin-setting-rights-user-data-unlock'>Unlock</td>
                          <td className='af-table-data af-superadmin-setting-rights-user-data-toggle-domain-unlock'>
                            <Form.Item
                              className='af-superadmin-setting-rights-user-form-item-domainunlock'
                              name={['portalAdminRights', 'portaluserUnlock']}
                              valuePropName='checked'
                            >
                              <AntToggleButton
                                className='af-form-switch af-superadmin-rights-user-toggle-domainunlock'
                                onChange={() => HandleUserViewButton('PortalAdminUser')}
                              />
                            </Form.Item>
                          </td>
                          <td className='af-table-data af-superadmin-setting-rights-user-data-toggle-ou-unlock'>
                            <Form.Item
                              className='af-superadmin-setting-rights-user-form-item-ouunlock'
                              name={['ouAdminRights', 'ouAdminuserUnlock']}
                              valuePropName='checked'
                            >
                              <AntToggleButton
                                className='af-form-switch af-superadmin-rights-user-toggle-ouunlock'
                                onChange={() => HandleUserViewButton('OuAdminUser')}
                              />
                            </Form.Item>
                          </td>
                        </tr>
                        <tr className='af-table-row af-superadmin-setting-rights-user-body-enable-disable'>
                          <td className='af-table-data af-superadmin-setting-rights-user-data-enable-disable'>
                            Enable / Disable
                          </td>
                          <td className='af-table-data af-superadmin-setting-rights-user-data-toggle-domain-enable-disable'>
                            <Form.Item
                              className='af-superadmin-setting-rights-user-form-item-domain-enable-disable'
                              name={['portalAdminRights', 'portaluserEnableDisable']}
                              valuePropName='checked'
                            >
                              <AntToggleButton
                                className='af-form-switch af-superadmin-rights-user-toggle-domain-enable-disable'
                                onChange={() => HandleUserViewButton('PortalAdminUser')}
                              />
                            </Form.Item>
                          </td>
                          <td className='af-table-data af-superadmin-setting-rights-user-data-toggle-ou-enable-disable'>
                            <Form.Item
                              className='af-superadmin-setting-rights-user-form-item-ou-enable-disable'
                              name={['ouAdminRights', 'ouAdminuserEnableDisable']}
                              valuePropName='checked'
                            >
                              <AntToggleButton
                                className='af-form-switch af-superadmin-rights-user-toggle-ou-enable-disable'
                                onChange={() => HandleUserViewButton('OuAdminUser')}
                              />
                            </Form.Item>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </TableContainer>

                <TableContainer className='af-superadmin-setting-rights-table-second-container'>
                  <div className='table-container af-superadmin-setting-rights-group-wrap'>
                    <table className='custom-table af-superadmin-setting-rights-group-table'>
                      <thead className='noheader af-superadmin-setting-rights-group-table-head'>
                        <tr className='af-table-row af-superadmin-setting-rights-group-table-head-row'>
                          <th className='af-table-th af-superadmin-setting-rights-group-rights-head'>Rights</th>
                          <th className='af-table-th af-superadmin-setting-rights-group-domain-head'>Domain Admin</th>
                          <th className='af-table-th af-superadmin-setting-rights-group-ou-head'>Ou Admin</th>
                        </tr>
                      </thead>
                      <tbody className='af-superadmin-setting-rights-group-table-body'>
                        <tr className='af-table-row af-superadmin-setting-rights-group-body-head'>
                          <HeadingColumn colSpan='3' className='af-superadmin-setting-rights-group-head-column'>
                            <HeadingData className='af-superadmin-setting-rights-group-head-data'>
                              Group Management
                            </HeadingData>
                          </HeadingColumn>
                        </tr>
                        <tr className='af-table-row af-superadmin-setting-rights-group-body-view'>
                          <td className='af-table-data af-superadmin-setting-rights-group-data-view'>View</td>
                          <td className='af-table-data af-superadmin-setting-rights-group-data-toggle-domain-view'>
                            <Form.Item
                              className='af-superadmin-setting-rights-group-form-item-domainview'
                              name={['portalAdminRights', 'portalgroupView']}
                              valuePropName='checked'
                            >
                              <AntToggleButton
                                className='af-form-switch af-superadmin-rights-group-toggle-domainview'
                                disabled={viewProperties.portalGroup}
                              />
                            </Form.Item>
                          </td>
                          <td className='af-table-data af-superadmin-setting-rights-group-data-toggle-ou-view'>
                            <Form.Item
                              className='af-superadmin-setting-rights-group-form-item-ouview'
                              name={['ouAdminRights', 'ouAdmingroupView']}
                              valuePropName='checked'
                            >
                              <AntToggleButton
                                className='af-form-switch af-superadmin-rights-group-toggle-ouview'
                                disabled={viewProperties.ouAdminGroup}
                              />
                            </Form.Item>
                          </td>
                        </tr>
                        <tr className='af-table-row af-superadmin-setting-rights-group-body-edit'>
                          <td className='af-table-data af-superadmin-setting-rights-group-data-edit'>Edit</td>
                          <td className='af-table-data af-superadmin-setting-rights-group-data-toggle-domain-edit'>
                            <Form.Item
                              className='af-superadmin-setting-rights-group-form-item-domainedit'
                              name={['portalAdminRights', 'portalgroupEdit']}
                              valuePropName='checked'
                            >
                              <AntToggleButton
                                className='af-form-switch af-superadmin-rights-group-toggle-domainedit'
                                onChange={() => HandleGroupViewButton('PortalAdminGroup')}
                              />
                            </Form.Item>
                          </td>
                          <td className='af-table-data af-superadmin-setting-rights-group-data-toggle-ou-edit'>
                            <Form.Item
                              className='af-superadmin-setting-rights-group-form-item-ouedit'
                              name={['ouAdminRights', 'ouAdmingroupEdit']}
                              valuePropName='checked'
                            >
                              <AntToggleButton
                                className='af-form-switch af-superadmin-rights-group-toggle-ouedit'
                                onChange={() => HandleGroupViewButton('OuAdminGroup')}
                              />
                            </Form.Item>
                          </td>
                        </tr>
                        <tr className='af-table-row af-superadmin-setting-rights-group-body-create'>
                          <td className='af-table-data af-superadmin-setting-rights-group-data-create'>Create</td>
                          <td className='af-table-data af-superadmin-setting-rights-group-data-toggle-domain-create'>
                            <Form.Item
                              className='af-superadmin-setting-rights-group-form-item-domaincreate'
                              name={['portalAdminRights', 'portalgroupCreate']}
                              valuePropName='checked'
                            >
                              <AntToggleButton className='af-form-switch af-superadmin-rights-group-toggle-domaincreate' />
                            </Form.Item>
                          </td>
                          <td className='af-table-data af-superadmin-setting-rights-group-data-toggle-ou-create'>
                            <Form.Item
                              className='af-superadmin-setting-rights-group-form-item-oucreate'
                              name={['ouAdminRights', 'ouAdmingroupCreate']}
                              valuePropName='checked'
                            >
                              <AntToggleButton className='af-form-switch af-superadmin-rights-group-toggle-oucreate' />
                            </Form.Item>
                          </td>
                        </tr>
                        <tr className='af-table-row af-superadmin-setting-rights-group-body-export'>
                          <td className='af-table-data af-superadmin-setting-rights-group-data-export'>Export</td>
                          <td className='af-table-data af-superadmin-setting-rights-group-data-toggle-domain-export'>
                            <Form.Item
                              className='af-superadmin-setting-rights-group-form-item-domainexport'
                              name={['portalAdminRights', 'portalgroupExport']}
                              valuePropName='checked'
                            >
                              <AntToggleButton className='af-form-switch af-superadmin-rights-group-toggle-domainexport' />
                            </Form.Item>
                          </td>
                          <td className='af-table-data af-superadmin-setting-rights-group-data-toggle-ou-export'>
                            <Form.Item
                              className='af-superadmin-setting-rights-group-form-item-ouexport'
                              name={['ouAdminRights', 'ouAdmingroupExport']}
                              valuePropName='checked'
                            >
                              <AntToggleButton className='af-form-switch af-superadmin-rights-group-toggle-ouexport' />
                            </Form.Item>
                          </td>
                        </tr>
                        <tr className='af-table-row af-superadmin-setting-rights-group-body-bulk'>
                          <td className='af-table-data af-superadmin-setting-rights-group-data-bulk'>Bulk Actions</td>
                          <td className='af-table-data af-superadmin-setting-rights-group-data-toggle-domain-bulk'>
                            <Form.Item
                              className='af-superadmin-setting-rights-group-form-item-domainbulk'
                              name={['portalAdminRights', 'portalgroupBulkAction']}
                              valuePropName='checked'
                            >
                              <AntToggleButton
                                className='af-form-switch af-superadmin-rights-group-toggle-domainbulk'
                                onChange={() => HandleGroupViewButton('PortalAdminGroup')}
                              />
                            </Form.Item>
                          </td>
                          <td className='af-table-data af-superadmin-setting-rights-group-data-toggle-ou-bulk'>
                            <Form.Item
                              className='af-superadmin-setting-rights-group-form-item-oubulk'
                              name={['ouAdminRights', 'ouAdmingroupBulkAction']}
                              valuePropName='checked'
                            >
                              <AntToggleButton
                                className='af-form-switch af-superadmin-rights-group-toggle-oubulk'
                                onChange={() => HandleGroupViewButton('OuAdminGroup')}
                              />
                            </Form.Item>
                          </td>
                        </tr>
                        <tr className='af-table-row af-superadmin-setting-rights-group-body-delete'>
                          <td className='af-table-data af-superadmin-setting-rights-group-data-delete'>Delete</td>
                          <td className='af-table-data af-superadmin-setting-rights-group-data-toggle-domain-delete'>
                            <Form.Item
                              className='af-superadmin-setting-rights-group-form-item-domaindelete'
                              name={['portalAdminRights', 'portalgroupDelete']}
                              valuePropName='checked'
                            >
                              <AntToggleButton
                                className='af-form-switch af-superadmin-rights-group-toggle-domaindelete'
                                onChange={() => HandleGroupViewButton('PortalAdminGroup')}
                              />
                            </Form.Item>
                          </td>
                          <td className='af-table-data af-superadmin-setting-rights-group-data-toggle-ou-delete'>
                            <Form.Item
                              className='af-superadmin-setting-rights-group-form-item-oudelete'
                              name={['ouAdminRights', 'ouAdmingroupDelete']}
                              valuePropName='checked'
                            >
                              <AntToggleButton
                                className='af-form-switch af-superadmin-rights-group-toggle-oudelete'
                                onChange={() => HandleGroupViewButton('OuAdminGroup')}
                              />
                            </Form.Item>
                          </td>
                        </tr>
                        <tr className='af-table-row af-superadmin-setting-rights-ou-body-head'>
                          <HeadingColumn colSpan='3' className='af-superadmin-setting-rights-ou-head-column'>
                            <HeadingData className='af-superadmin-setting-rights-ou-head-data'>
                              OU Management
                            </HeadingData>
                          </HeadingColumn>
                        </tr>
                        <tr className='af-table-row af-superadmin-setting-rights-ou-body-view'>
                          <td className='af-table-data af-superadmin-setting-rights-ou-data-view'>View</td>
                          <td className='af-table-data af-superadmin-setting-rights-ou-data-toggle-domain-view'>
                            <Form.Item
                              className='af-superadmin-setting-rights-ou-form-item-domainview'
                              name={['portalAdminRights', 'portalouView']}
                              valuePropName='checked'
                            >
                              <AntToggleButton
                                className='af-form-switch af-superadmin-rights-ou-toggle-domainview'
                                disabled={viewProperties.portalOu}
                              />
                            </Form.Item>
                          </td>
                          <td className='af-table-data af-superadmin-setting-rights-ou-data-toggle-ou-view'>
                            <Form.Item
                              className='af-superadmin-setting-rights-ou-form-item-ouview'
                              name={['ouAdminRights', 'ouAdminouView']}
                              valuePropName='checked'
                            >
                              <AntToggleButton
                                className='af-form-switch af-superadmin-rights-ou-toggle-ouview'
                                disabled={viewProperties.ouAdminOu}
                              />
                            </Form.Item>
                          </td>
                        </tr>
                        <tr className='af-table-row af-superadmin-setting-rights-ou-body-edit'>
                          <td className='af-table-data af-superadmin-setting-rights-ou-data-edit'>Edit</td>
                          <td className='af-table-data af-superadmin-setting-rights-ou-data-toggle-domain-edit'>
                            <Form.Item
                              className='af-superadmin-setting-rights-ou-form-item-domainedit'
                              name={['portalAdminRights', 'portalouEdit']}
                              valuePropName='checked'
                            >
                              <AntToggleButton
                                className='af-superadmin-setting-rights-ou-form-item-domainedit'
                                onChange={() => HandleOuViewButton('PortalAdminOU')}
                              />
                            </Form.Item>
                          </td>
                          <td className='af-table-data af-superadmin-setting-rights-ou-data-toggle-ou-edit'>
                            <Form.Item
                              className='af-superadmin-setting-rights-ou-form-item-ouedit'
                              name={['ouAdminRights', 'ouAdminouEdit']}
                              valuePropName='checked'
                            >
                              <AntToggleButton
                                className='af-form-switch af-superadmin-rights-ou-toggle-ouedit'
                                onChange={() => HandleOuViewButton('OuAdminOU')}
                              />
                            </Form.Item>
                          </td>
                        </tr>
                        <tr className='af-table-row af-superadmin-setting-rights-ou-body-create'>
                          <td className='af-table-data af-superadmin-setting-rights-ou-data-create'>Create</td>
                          <td className='af-table-data af-superadmin-setting-rights-ou-data-toggle-domain-create'>
                            <Form.Item
                              className='af-superadmin-setting-rights-ou-form-item-domaincreate'
                              name={['portalAdminRights', 'portalouCreate']}
                              valuePropName='checked'
                            >
                              <AntToggleButton className='af-form-switch af-superadmin-rights-ou-toggle-domaincreate' />
                            </Form.Item>
                          </td>
                          <td className='af-table-data af-superadmin-setting-rights-ou-data-toggle-ou-create'>
                            <Form.Item
                              className='af-superadmin-setting-rights-ou-form-item-oucreate'
                              name={['ouAdminRights', 'ouAdminouCreate']}
                              valuePropName='checked'
                            >
                              <AntToggleButton className='af-form-switch af-superadmin-rights-ou-toggle-oucreate' />
                            </Form.Item>
                          </td>
                        </tr>
                        <tr className='af-table-row af-superadmin-setting-rights-ou-body-export'>
                          <td className='af-table-data af-superadmin-setting-rights-ou-data-export'>Export</td>
                          <td className='af-table-data af-superadmin-setting-rights-ou-data-toggle-domain-export'>
                            <Form.Item
                              className='af-superadmin-setting-rights-ou-form-item-domainexport'
                              name={['portalAdminRights', 'portalouExport']}
                              valuePropName='checked'
                            >
                              <AntToggleButton className='af-form-switch af-superadmin-rights-ou-toggle-domainexport' />
                            </Form.Item>
                          </td>
                          <td className='af-table-data af-superadmin-setting-rights-ou-data-toggle-ou-export'>
                            <Form.Item
                              className='af-superadmin-setting-rights-ou-form-item-ouexport'
                              name={['ouAdminRights', 'ouAdminouExport']}
                              valuePropName='checked'
                            >
                              <AntToggleButton className='af-form-switch af-superadmin-rights-ou-toggle-ouexport' />
                            </Form.Item>
                          </td>
                        </tr>
                        <tr className='af-table-row af-superadmin-setting-rights-ou-body-delete'>
                          <td className='af-table-data af-superadmin-setting-rights-ou-data-delete'>Delete</td>
                          <td className='af-table-data af-superadmin-setting-rights-ou-data-toggle-domain-delete'>
                            <Form.Item
                              className='af-superadmin-setting-rights-ou-form-item-domaindelete'
                              name={['portalAdminRights', 'portalouDelete']}
                              valuePropName='checked'
                            >
                              <AntToggleButton
                                className='af-form-switch af-superadmin-rights-ou-toggle-domaindelete'
                                onChange={() => HandleOuViewButton('PortalAdminOU')}
                              />
                            </Form.Item>
                          </td>
                          <td className='af-table-data af-superadmin-setting-rights-ou-data-toggle-ou-delete'>
                            <Form.Item
                              className='af-superadmin-setting-rights-ou-form-item-oudelete'
                              name={['ouAdminRights', 'ouAdminouDelete']}
                              valuePropName='checked'
                            >
                              <AntToggleButton
                                className='af-form-switch af-superadmin-rights-ou-toggle-oudelete'
                                onChange={() => HandleOuViewButton('OuAdminOU')}
                              />
                            </Form.Item>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </TableContainer>
              </TableWrap>
            </Form>
          </ContentWrapper>
          <ButtonWrap className='af-superadmin-setting-button-wrap'>
            <StyledButton className='af-superadmin-setting-button' type='primary' htmlType='submit'>
              Submit
            </StyledButton>
          </ButtonWrap>
        </Form>
      </AdminPageSizeWrap>
    </AdminPageWrap>
  );
}
